export const trainingRoutes = {
  SEND_SCHOOL_TRAINING_ORDER: "/email/application",
  SEND_PERSONAL_TRAINING_ORDER: "/email/training",
}